import * as React from 'react';
import styled from 'styled-components';

import { getMeasureProp } from '../../styles';
import type { SpacerProps } from './spacer';


const cssMap = {
	horizontal: (size) => `width: ${getMeasureProp(size)};`,
	vertical: (size) => `height: ${getMeasureProp(size)};`,
	all: (size) => `
		width: ${getMeasureProp(size)};
		height: ${getMeasureProp(size)};
	`,
};

const Root = styled(({ size, appearance, ...rest }) => <div {...rest} />)`
	display: inline-block;
	${(p: SpacerProps) => cssMap[p.appearance] ? cssMap[p.appearance](p.size) : ''}
`;

export {
	Root,
};

